import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';

import { TopBarNavAutocompleteComponent } from './top-bar-nav-autocomplete.component';

@NgModule({
    imports: [BaseAutocompleteModule, CommonModule],
    declarations: [TopBarNavAutocompleteComponent],
    exports: [TopBarNavAutocompleteComponent],
})
export class TopBarNavAutocompleteModule {}
